module.exports = __webpack_public_path__ + "static/img/zyh.5bd2bbbd.png";